import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendStaffAppMetaData } from '../eventTriggers'
import moment from 'moment'

export function Vaccines() {
  const { vaccines } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'vaccines'))
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "vaccine",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }

  return (
    <div>
      {
        vaccines.map(vaccine=>(
          <div key={vaccine.id} onClick={()=>handleClick(vaccine)} className="p-4 border-bottom clickable">
            <b>{vaccine.kind}</b>
            <div>{ vaccine.received_on ? moment(vaccine.received_on).format('MM/DD/YYYY') : null}</div>
          </div>
        ))
      }
    </div>
  )
}
